import TemplateView from '../components/templates/BsTemplateView.vue'
import Login from '../components/templates/BsLoginView.vue'
import Logout from '../components/templates/BsLogoutView.vue'
import PrivacyPolicy from '../components/templates/BsPrivacyPolicyView.vue'
import NonLoginFile from '../components/templates/BsNonLoginFileView.vue'
import Error from '../components/templates/BsErrorView.vue'
import DashBoard from '../components/templates/BsDashBoardView.vue'
// 会員情報
import UserIndex from '../components/templates/User/IndexView.vue'
import UserDetail from '../components/templates/User/DetailView.vue'
import UserGuest from '../components/templates/User/GuestView.vue'
import UserFriend from '../components/templates/User/FriendView.vue'
import UserEdit from '../components/templates/User/EditView.vue'
import UserCar from '../components/templates/User/CarView.vue'
import UserCheckin from '../components/templates/User/CheckinView.vue'
import UserKIyaku from '../components/templates/User/KiyakuView.vue'
import UserPolicy from '../components/templates/User/PolicyView.vue'
import UserAccess from '../components/templates/User/AccessView.vue'

import Inquiry from '../components/templates/Inquiry/IndexView.vue'

// 予約
import Reservation from '../components/templates/Reservation/IndexView.vue'
// 走行予約
import RsvDrive from '../components/templates/Reservation/DriveView.vue'
// import RsvDrive2 from '../components/templates/Reservation/Drive2View.vue'
// 宿泊予約
import RsvLodging from '../components/templates/Reservation/LodgingView.vue'
// 宿泊予約
import RsvPlanLodging from '../components/templates/Reservation/LodgingPlanView.vue'
// その他予約
import RsvFacility from '../components/templates/Reservation/FacilityView.vue'
// その他予約
import RsvOther from '../components/templates/Reservation/OtherView.vue'
// 予約
import Reserved from '../components/templates/Reserved/IndexView.vue'
// 走行予約
import RsvedDrive from '../components/templates/Reserved/DriveView.vue'
// 宿泊予約
import RsvedLodging from '../components/templates/Reserved/LodgingView.vue'
// 施設予約
import RsvedFacility from '../components/templates/Reserved/FacilityView.vue'
// その他予約
import RsvedOther from '../components/templates/Reserved/OtherView.vue'
// 履歴
import History from '../components/templates/History/IndexView.vue'
import HistoryDrive from '../components/templates/History/DriveView.vue'
import HistoryLodging from '../components/templates/History/LodgingView.vue'
import HistoryOther from '../components/templates/History/OtherView.vue'
import HistoryFacility from '../components/templates/History/FacilityView.vue'
// インフォメーション
import InformationList from '../components/templates/Information/ListView.vue'
import InformationData from '../components/templates/Information/DataView.vue'
// メッセージ
import Message from '../components/templates/Message/IndexView.vue'

import TeaserView from '../components/templates/BsTeaserView.vue'

import FilesView from '../components/templates/Files/DataView.vue'


export default [
    {
        path: '/',
        name: 'base',
        component: TemplateView,
        meta: {
            requiresAuth: true
        },
        props: true,
        children: [
            {
                path: '/',
                name: 'dashboard',
                component: DashBoard,
            },
        ]
    },
    // {
    //     path: '/policy',
    //     name: 'policy',
    //     component: PrivacyPolicy,
    // },
    {
        path: '/policy',
        name: 'non_req',
        component: PrivacyPolicy,
        meta: {
            requiresAuth: false
        },
        props: true,
        children: [
            {
                path: '',
                name: 'policy',
                component: UserPolicy,
            },
        ]
    },
    {
        path: '/user',
        name: 'user',
        component: TemplateView,
        meta: {
            // requiresAuth: true
        },
        children: [
            {
                path: '/user/detail',
                name: 'user_detail',
                component: UserDetail,
            },
            {
                path: '/user/edit',
                name: 'user_edit',
                component: UserEdit,
            },
            {
                path: '/user/guest',
                name: 'user_guest',
                component: UserGuest,
            },
            {
                path: '/user/friend',
                name: 'user_friend',
                component: UserFriend,
            },
            {
                path: '/user/index',
                name: 'user_index',
                component: UserIndex,
            },
            {
                path: '/user/car',
                name: 'user_car',
                component: UserCar,
            },
            {
                path: '/user/checkin',
                name: 'user_checkin',
                component: UserCheckin,
            },
            {
                path: '/user/policy',
                name: 'user_policy',
                component: UserPolicy,
            },
            {
                path: '/user/kiyaku',
                name: 'user_kiyaku',
                component: UserKIyaku,
            },
            {
                path: '/user/access',
                name: 'user_access',
                component: UserAccess,
            },
        ]
    },
    {
        path: '/reservation',
        name: 'Reservation',
        component: TemplateView,
        meta: {
            // requiresAuth: true
        },
        children: [
            {
                path: '/reservation/index',
                name: 'reservation_index',
                component: Reservation,
            },
            {
                path: '/reservation/drive',
                name: 'reservation_drive',
                component: (process.env.NODE_ENV === 'sandbox')? RsvDrive: RsvDrive,
                // component: (process.env.NODE_ENV === 'sandbox')? RsvDrive2: RsvDrive,
            },
            {
                path: '/reservation/drive2',
                name: 'reservation_drive2',
                component: RsvDrive,
            },
            {
                path: '/reservation/lodging',
                name: 'reservation_lodging',
                component: RsvLodging,
            },
            {
                path: '/reservation/plan',
                name: 'reservation_plan',
                component: RsvPlanLodging,
            },
            {
                path: '/reservation/facility',
                name: 'reservation_facility',
                component: RsvFacility,
            },
            {
                path: '/reservation/other',
                name: 'reservation_other',
                component: RsvOther,
            }
        ]
    },
    {
        path: '/reserved',
        name: 'Reserved',
        component: TemplateView,
        meta: {
            // requiresAuth: true
        },
        children: [
            {
                path: '/reserved/index',
                name: 'Reserved_index',
                component: Reserved,
            },
            {
                path: '/reserved/drive',
                name: 'Reserved_drive',
                component: RsvedDrive,
            },
            {
                path: '/reserved/lodging',
                name: 'Reserved_lodging',
                component: RsvedLodging,
            },
            {
                path: '/reserved/facility',
                name: 'Reserved_facility',
                component: RsvedFacility,
            },
            {
                path: '/reserved/other',
                name: 'Reserved_other',
                component: RsvedOther,
            }
        ]
    },
    {
        path: '/history',
        name: 'history',
        component: TemplateView,
        meta: {
            // requiresAuth: true
        },
        children: [
            {
                path: '/history/index',
                name: 'history_index',
                component: History,
            },
            {
                path: '/history/drive',
                name: 'history_drive',
                component: HistoryDrive,
            },
            {
                path: '/history/lodging',
                name: 'history_lodging',
                component: HistoryLodging,
            },
            {
                path: '/history/facility',
                name: 'history_facility',
                component: HistoryFacility,
            },
            {
                path: '/history/other',
                name: 'history_other',
                component: HistoryOther,
            }
        ]
    },
    {
        path: '/inquiry',
        name: 'inquiry',
        component: TemplateView,
        children: [
            {
                path: '/inquiry/index',
                name: 'inquiry_index',
                component: Inquiry,
            }
        ]
    },
    {
        path: '/information',
        name: 'information',
        component: TemplateView,
        meta: {
            // requiresAuth: true
        },
        children: [
            {
                path: '/information/list',
                name: 'information_list',
                component: InformationList,
            },
            {
                path: '/information/:id',
                name: 'information_detail',
                component: InformationData,
            }
        ]
    },
    {
        path: '/files',
        name: 'files',
        component: NonLoginFile,
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: '/files/list',
                name: 'files_list',
                component: FilesView,
            },
            {
                path: '/files/:id',
                name: 'files_detail',
                component: FilesView,
            }
        ]
    },
    {
        path: '/fpage',
        name: 'filepage',
        component: TemplateView,
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: '/fpage/list',
                name: 'fpage_list',
                component: FilesView,
            },
            {
                path: '/fpage/:id',
                name: 'fpage_detail',
                component: FilesView,
            }
        ]
    },
    {
        path: '/message',
        name: 'message',
        component: TemplateView,
        children: [
            {
                path: '/message/index',
                name: 'message_index',
                component: Message,
            }
        ]
    },
    {
        path: '/teaser_pg',
        name: 'teaser',
        component: TeaserView,
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
    {
        path: '/logout',
        name: 'logout',
        component: Logout
    },
    {
        path: '/data/list',
        name: 'DataList',
        component: TemplateView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/error',
        name: 'error',
        component: Error
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: './error'
    }
]
